/**
 * Stops the trackers for this page view. An admin session ("Log in as this user") sets it, so an
 * admin visit does not count as activity of the user.
 *
 * It only goes on: the end of an admin session loads the page again, and that starts clean.
 * This module has no imports, so the code that runs before the app boots can use it.
 */
let paused = false;

export function pauseAnalytics(): void {
  paused = true;
}

export function isAnalyticsPaused(): boolean {
  return paused;
}

/** For tests only. */
export function resetAnalyticsPauseForTests(): void {
  paused = false;
}
